import { Trans, useTranslation } from "react-i18next";
import teaserFittinge from "../assets/images/teaser_fittinge.jpg";
import teaserGurte from "../assets/images/teaser_gurte.jpg";
import teaserSchienen from "../assets/images/teaser_schienen.jpg";
import { useContext } from "react";
import { Context } from "../ContextProvider";
import { LANGUAGE } from "../type";

const TeasersSection = () => {
  const { t } = useTranslation();
  const { language } = useContext(Context);

  return (
    <section className="max-w-screen-2xl mx-auto w-full mt-8 xl:mt-20">
      <div className="px-6 2xl:px-0">
        <div className="max-w-2xl mx-auto flex flex-col items-center">
          <h2 className="font-inter-bold text-center text-allsafe-blue text-2xl leading-14 xl:text-4xl">
            {t("Unser Sortiment")}
          </h2>
          <p className="font-inter-regular text-base leading-6 text-center">
            <Trans>
							Unser Sortiment umfasst alles, was Sie zur Sicherung Ihrer Fracht
							benötigen. Von Airline-Schienen und Gurten bis hin zu Netzen,
							Sperrelementen und Beschlägen.
            </Trans>
          </p>
          <a
            href={
              language === LANGUAGE.DE
                ? "https://allsafe24.com/produkte-und-systeme/produkte"
                : "https://allsafe24.com/en/produkte-und-systeme/produkte"
            }
            className="text-allsafe-blue cursor-pointer mx-1 underline text-center"
            target="_blank"
            rel="noreferrer"
          >
            <Trans>Entdecken Sie das gesamte Produktsortiment.</Trans>
          </a>
        </div>
        <div className="flex flex-col space-y-10 xl:space-y-0 xl:flex-row xl:space-x-6 items-stretch mt-8">
          <div className="flex flex-col justify-between">
            <div className="w-full h-64 xl:h-52">
              <img
                src={teaserSchienen}
                alt="teaserSchienen"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-allsafe-blue-500 text-base leading-6 font-inter-semibold mt-6 mb-2">
              <Trans>Schienen</Trans>
            </div>
            <div className="text-base leading-6 font-inter-regular mb-8">
              <Trans>
								Freie Fahrt garantiert unser vielfältiges Schienensortiment. Für
								jeden Fahrzeugtyp und für jeden Einsatzbereich die richtige
								Schiene. Unsere verschiedenen Schienen-Typen gepaart mit den
								passenden Zurrpunkten und Sperrstangen versprechen
								Ladungssicherung auf höchstem Niveau.
              </Trans>
            </div>
            <div>
              <a
                href={
                  language === LANGUAGE.DE
                    ? "https://allsafe24.com/produkte-und-systeme/produkte/schienen"
                    : "https://allsafe24.com/en/produkte-und-systeme/produkte/schienen"
                }
                className="bg-allsafe-blue-400 shadow-[0px_4px_0px_0px_#2f579c] font-inter-regular rounded-md text-allsafe-white text-xs px-4 py-3"
                target="_blank"
                rel="noreferrer"
              >
                <Trans>Schienen ansehen</Trans>
              </a>
            </div>
          </div>
          <div className="flex flex-col justify-between">
            <div className="w-full h-64 xl:h-52">
              <img
                src={teaserFittinge}
                alt="teaserFittinge"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-allsafe-blue-500 text-base leading-6 font-inter-semibold mt-6 mb-2">
              <Trans>KERL Fittinge</Trans>
            </div>
            <div className="text-base leading-6 font-inter-regular mb-8">
              <Trans>
								KERLs sind Fittinge für eine Vielzahl an Anforderungen und
								stehen für beste Qualität und höchste Sicherheit Made in
								Germany. Auf Grund ihrer Variationsvielfalt sind sie flexibel
								einsetzbar und der ideale Partner für verschiedene Arten von
								Schienen. Die KERL Fitting-Familie steht für optimale
								Ladungssicherung.
              </Trans>
            </div>
            <div>
              <a
                href={
                  language === LANGUAGE.DE
                    ? "https://allsafe24.com/produkte-und-systeme/produkte/fittinge"
                    : "https://allsafe24.com/en/produkte-und-systeme/produkte/fittinge"
                }
                className="bg-allsafe-blue-400 shadow-[0_4px_0_0_#2f579c] font-inter-regular rounded-md text-allsafe-white text-xs px-4 py-3"
                target="_blank"
                rel="noreferrer"
              >
                <Trans>Fittinge ansehen</Trans>
              </a>
            </div>
          </div>
          <div className="flex flex-col justify-between">
            <div className="w-full h-64 xl:h-52">
              <img
                src={teaserGurte}
                alt="teaserGurte"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-allsafe-blue-500 text-base leading-6 font-inter-semibold mt-6 mb-2">
              <Trans>Gurte</Trans>
            </div>
            <div className="text-base leading-6 font-inter-regular font-medium mb-8">
              <Trans>
								Unsere Zurr- und Ringgurte sind robuste Maßkonfektionen und für
								Ladungssicherung in Transportern und auf LKWs geeignet. Die
								Gurte ermöglichen Ihnen maximale Sicherheit bei höchster
								Qualität. Unsere Produkte zeichnen sich außerdem durch eine
								lange Lebensdauer aus.
              </Trans>
            </div>
            <div>
              <a
                href={
                  language === LANGUAGE.DE
                    ? "https://allsafe24.com/produkte-und-systeme/produkte/gurte"
                    : "https://allsafe24.com/en/produkte-und-systeme/produkte/gurte"
                }
                className="bg-allsafe-blue-400 shadow-[0_4px_0_0_#2f579c] font-inter-regular rounded-md text-allsafe-white text-xs px-4 py-3"
                target="_blank"
                rel="noreferrer"
              >
                <Trans>Gurte ansehen</Trans>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeasersSection;
